import React from 'react'
import { reportViewSurveyBanner, reportStartSurveyClick } from '../../../common/analytics/surveyBannerAnalytics'
import { setLocalStorageItem, getLocalStorageItem } from '../../../common/utils/localStorageHelpers'
import styles from './photoduneSearchSurveyBanner.module.css'

class PhotoduneSearchSurveyBanner extends React.Component {
  constructor (props) {
    super(props)
    this.state = { dismissed: this.isDismissed() }
  }

  dismiss () {
    setLocalStorageItem('pd-search-survey-banner-visibility', 'hidden')
    this.setState({ dismissed: true })
  }

  isDismissed () {
    return getLocalStorageItem('pd-search-survey-banner-visibility', 'visible') === 'hidden'
  }

  onDismiss = (event) => {
    event.preventDefault()
    this.dismiss()
  }

  onStartSurvey = (event) => {
    reportStartSurveyClick('PD Search Survey')
    this.dismiss()
  }

  componentDidMount () {
    if (!this.state.dismissed) reportViewSurveyBanner('PD Search Survey')
  }

  render () {
    if (this.state.dismissed) {
      return null
    }

    // Search Survey Banner temproraly uses Alert styles until there is a Survey Component in Design System.
    // Alert styles should be replaced with appropriate Survey Component styles by Sept 2017
    return (
      <div className={`fds-c-alert-box ${styles.backgroundDark} fds-u-mt2 -type-success`}>
        <div className='fds-c-alert-box__icon'>
          <i className='e-icon -icon-ok' />
        </div>
        <div className='fds-c-alert-box__message'>
          <div className='fds-c-text-body -size-s fds-u-m0'>
            <p className={styles.surveyText}>
              <span className='fds-u-hide-medium-and-below'>
                How&apos;s searching for photos on PhotoDune? Rewarding? Frustrating? We&apos;d love to know.
              </span>
              <PhotoduneSearchSurveyBanner.SurveyLink onClick={this.onStartSurvey} />
            </p>
          </div>
        </div>
        <PhotoduneSearchSurveyBanner.SurveyButton onClick={this.onStartSurvey} />
        <PhotoduneSearchSurveyBanner.DismissButton onClick={this.onDismiss} />
      </div>
    )
  }
}

PhotoduneSearchSurveyBanner.SurveyLink = ({onClick}) => {
  const classNames = `${styles.surveyText} fds-u-hide-medium-and-above`

  return (
    <a onClick={onClick} href='https://envato.formstack.com/forms/photodune_survey' target='_blank' className={classNames}>
      How&apos;s searching for photos on PhotoDune? Rewarding? Frustrating? We&apos;d love to know.
    </a>
  )
}

PhotoduneSearchSurveyBanner.SurveyButton = ({onClick}) => {
  const classNames = `fds-u-hide-medium-and-below fds-c-button--3d -color-primary`

  return (
    <a onClick={onClick} href='https://envato.formstack.com/forms/photodune_survey' target='_blank' className={classNames}>
      Share your experience
    </a>
  )
}

PhotoduneSearchSurveyBanner.DismissButton = ({onClick}) => {
  return (
    <div className='fds-c-alert-box__dismiss'>
      <a onClick={onClick} className='fds-c-alert-box__dismiss-icon'>
        <i className='e-icon -icon-cancel -color-white' />
      </a>
    </div>
  )
}

export default PhotoduneSearchSurveyBanner



// WEBPACK FOOTER //
// ./client/components/banners/photoduneSearchSurveyBanner.js